export const AIRLINE_SECTION_TYPE_ID = 'airline-section';
export const EXTERNAL_LINK_TYPE_ID = 'external-link';
export const INTERNAL_LINK_TYPE_ID = 'internal-link';
export const TEXT_SECTION_TYPE_ID = 'text-section';
export const ACCORDION_ITEM_TYPE_ID = 'accordion-item';
export const ACCORDION_SECTION_TYPE_ID = 'accordion-section';
export const GENERIC_CONTENT_PAGE_TYPE_ID = 'page';
export const CARD_SECTION_TYPE_ID = 'card-section';
export const CARD_ITEM_TYPE_ID = 'card-item';
export const CONTACT_ITEM_TYPE_ID = 'contact-item';
export const CONTACT_SECTION_TYPE_ID = 'contact-section';
export const QUICK_LINKS_SECTION_TYPE_ID = 'quick-links-section';
export const CALL_TO_ACTION_SECTION_TYPE_ID = 'call-to-action-section';
export const EMAIL_LINK_TYPE_ID = 'email-link';
export const PHONE_LINK_TYPE_ID = 'phone-link';
export const ASSET_LINK_TYPE_ID = 'asset-link';
export const HIGHLIGHT_SECTION_TYPE_ID = 'highlight-section';
export const NEWS_SECTION_TYPE_ID = 'news-section';
export const BLOG_SECTION_TYPE_ID = 'blog-section';
export const CONTENT_CATEGORY_TYPE_ID = 'content-category';
export const NEWS_ITEM_TYPE_ID = 'news-item';
export const PRESS_RELEASE_TYPE_ID = 'press-release';
export const MEDIA_LIBRARY_TYPE_ID = 'media-library';
export const MEDIA_RESOURCE_TYPE_ID = 'media-resource-factsheet';
export const BLOG_ITEM_TYPE_ID = 'blog-item';
export const NEWS_ALERT_TYPE_ID = 'news-alert';
export const FOOTER_TYPE_ID = 'footer';
export const AIRLINE_TYPE_ID = 'airline';
export const AIRPORT_TYPE_ID = 'airport';
export const IFRAME_SECTION_TYPE_ID = 'iframe-section';
export const MENU_ITEM_TYPE_ID = 'menu-item';
export const SUBMENU_ITEM_TYPE_ID = 'submenu-item';
export const SITE_SECTION_ID = 'site-section';
export const CUSTOM_PAGES_CONTAINER_TYPE_ID = 'custom-pages';
export const JOB_TYPE_ID = 'job';
export const NEWS_CAROUSEL_SECTION_TYPE_ID = 'carousel-section';
export const NON_STOP_DESTINATIONS_TABLE_SECTION_TYPE_ID =
	'non-stop-destinations-table-section';
export const NON_STOP_DESTINATIONS_TABLE_ROW_TYPE_ID =
	'nonstop-destinations-table-row';
export const IMAGE_CAROUSEL_SECTION_TYPE_ID = 'imageCarouselSection';
export const TIMELINE_SECTION_TYPE_ID = 'timelineSection';
export const TIMELINE_CARD_TYPE_ID = 'timelineCard';
